export default __webpack_public_path__ + "static/media/saloon.a18a85fa.jpg";